module.exports = __webpack_public_path__ + "img/red-icon-en(2).f78a74fb.png";